import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si no sé absolutamente nada de LSA?',
    a: 'El Megapack empieza desde cero absoluto. El Tomo 1 asume que nunca viste una seña en tu vida y te lleva paso a paso desde el abecedario hasta la conversación real.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Apenas confirmado el pago recibís el acceso por email en menos de 5 minutos. Compatible con celular, tablet y computadora. También podés imprimirlo.'
  }, {
    q: '¿Está adaptado al LSA argentino?',
    a: 'Sí, completamente. Todo el contenido está contextualizado para Argentina en 2026. No es LSA americano, español ni internacional genérico. Es el LSA que se habla en Argentina.'
  }, {
    q: '¿Necesito algún conocimiento previo?',
    a: 'No. Solo ganas de aprender. El material es completamente autodidacta y progresivo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días. Si no estás conforme por cualquier motivo, te devolvemos el 100% sin preguntas. Escribinos a packcentral23@gmail.com'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-slate-900" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-700 rounded-2xl overflow-hidden bg-slate-800/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-slate-700 pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}